import type { ImpersonatedUser } from '@doneverse/data/api'

const STORAGE_KEY = 'doneverse.impersonating'

export function getImpersonatedUser(): ImpersonatedUser | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as ImpersonatedUser
  } catch {
    return null
  }
}

export function setImpersonatedUser(user: ImpersonatedUser | null): void {
  if (user) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(STORAGE_KEY)
  }
}
